import React from "react";

function SMSEmailSent() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 58 58"
    >
      <g fill="none">
        <path
          fill="#f0c419"
          d="M57.27 23.48a3.79 3.79 0 00-.6-.67L45.48 12.78l-.01-.01H12.53l-.01.01L1.33 22.81A4.053 4.053 0 000 25.79V54a4.007 4.007 0 004 4h50a4.007 4.007 0 004-4V25.79c0-.827-.254-1.634-.73-2.31z"
          data-original="#f0c419"
        ></path>
        <path
          fill="#f0c419"
          d="M57.27 23.48L33.83 40.5l-2.54 1.84a3.998 3.998 0 01-4.62.05l-2.62-1.81L.33 24.21a3.838 3.838 0 011-1.4l11.19-10.03.01-.01h32.94l.01.01 11.19 10.03c.226.199.427.424.6.67z"
          data-original="#f0c419"
        ></path>
        <path
          fill="#f29c1f"
          d="M24.05 40.58L1.37 57.01A3.98 3.98 0 010 54V25.79a3.858 3.858 0 01.33-1.58z"
          data-original="#f29c1f"
        ></path>
        <path
          fill="#e57e25"
          d="M56.63 57.01A3.985 3.985 0 0154 58H4a3.985 3.985 0 01-2.63-.99l22.68-16.43 2.62 1.81a3.998 3.998 0 004.62-.05l2.54-1.84z"
          data-original="#e57e25"
        ></path>
        <path
          fill="#f29c1f"
          d="M58 25.79V54a3.98 3.98 0 01-1.37 3.01L33.83 40.5l23.44-17.02c.476.676.73 1.483.73 2.31z"
          data-original="#f29c1f"
        ></path>
        <circle
          cx="29"
          cy="17"
          r="17"
          fill="#ff5364"
          data-original="#ff5364"
        ></circle>
        <path
          fill="#fff"
          d="M40.83 16.37l-8 7.5a.497.497 0 01-.83-.37V21a1.003 1.003 0 00-1-1h-7a4.985 4.985 0 00-5 5v-6a6.995 6.995 0 017-7h5a1.003 1.003 0 001-1V8.5a.497.497 0 01.83-.37l8 7.5a.483.483 0 010 .74z"
          data-original="#ffffff"
        ></path>
      </g>
    </svg>
  );
}

export default SMSEmailSent;
